import { DialogContentText, DialogTitle, Tooltip } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DatePicker from "@mui/lab/DatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { MenuItem, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import {
  hasInvalidPoItemUnCode,
  hasInvalidUnCode,
  isInvalidMaxPickupNumber,
  isInvalidMaxWareHouseRemarks,
} from "../../helper/HelperFunctions";
import {
  hasInvalidPalletSpaces,
  hasInvalidShipUnits,
  hasInvalidSlipSheets,
  hasInvalidTotals,
  isDivisibleShipQuantity,
  isInvalidPalletSpacesValue,
  isInvalidSlipSheetsValue,
} from "../../helper/ShipUnitUtilities";
import { getJsonResult, post } from "../../services/FetchServices";
import Location from "../../types/Location";
import PoItem from "../../types/PoItem";
import PoItemShipUnit from "../../types/PoItemShipUnit";
import PurchaseOrderRelease from "../../types/PurchaseOrderRelease";
import SearchOrderRelease from "../../types/SearchOrderRelease";
import CollapsibleSection from "../collapsibleSection/CollapsibleSection";
import { AutoDropDown } from "../dropDown/AutoDropDown";
import { DropDown } from "../dropDown/DropDown";
import {
  FlagableTextField,
  focusOnField,
} from "../purchaseOrderRelease/FlagableTextField";
import OrderReleaseDetailsPoItemShipUnitPage from "../purchaseOrderRelease/OrderReleaseDetailsPoItemShipUnitPage";

interface IState {
  purchaseOrderRelease?: PurchaseOrderRelease;
  hazmatCodes: string[];
  locations: Location[];
  searchOrderRelease: SearchOrderRelease;
  isPageEditable: boolean;
}

type POItemIdMap = {
  [poId: string]: string;
};

const OrderReleaseDetailsPage: React.FC = () => {
  const history = useHistory();
  const nmfcDefaultValue = "70";
  const location = useLocation();

  const [vendorId, setVendorId] = useState("");
  const [masterVendorName, setMasterVendorName] = useState("");
  const [orderReleaseId, setOrderReleaseId] = useState("");
  const [orderReleaseStatus, setOrderReleaseStatus] = useState("");
  const [earlyPickupDate, setEarlyPickupDate] = useState("");
  const [latePickupDate, setLatePickupDate] = useState("");
  const [earlyDeliveryDate, setEarlyDeliveryDate] = useState("");
  const [lateDeliveryDate, setLateDeliveryDate] = useState("");
  const [totalWeightValue, setTotalWeightValue] = useState("");
  const [totalVolumeValue, setTotalVolumeValue] = useState("");
  const [palletSpaces, setPalletSpaces] = useState("");
  const [pallets, setPallets] = useState("");
  const [palletSlipSheets, setPalletSlipSheets] = useState("");
  const [totalCartons, setTotalCartons] = useState("");
  const [loadMethod, setLoadMethod] = useState("");
  const [shipFrom, setShipFrom] = useState("");
  const [shipFromLocation, setShipFromLocation] = useState("");
  const [shipTo, setShipTo] = useState("");
  const [shipToTemp, setShipToTemp] = useState("");
  const [shipToAddress, setShipToAddress] = useState("");
  const [freightTerms, setFreightTerms] = useState("");
  const [earlyProductReadyDate, setEarlyProductReadyDate] =
    useState<Date | null>(null);
  const [earlyProductReadyDateMinimum, setEarlyProductReadyDateMinimum] =
    useState<Date | null>(null);
  const [lateProductReadyDate, setLateProductReadyDate] = useState<Date | null>(
    null,
  );
  const [advancedOption, setAdvancedOption] = useState("");
  const [earlyShipPoDate, setEarlyShipPoDate] = useState<Date | null>(null);
  const [earlyShipDate, setEarlyShipDate] = useState<Date | null>(null);
  const [earlyShipPoDateDup, setEarlyShipPoDateDup] = useState<Date | null>(
    null,
  );
  const [earlyProductReadyDateStart, setEarlyProductReadyDateStart] =
    useState<Date>(new Date());
  const [earlyProductReadyDateEnd, setEarlyProductReadyDateEnd] =
    useState<Date>(new Date());
  const [lateShipPoDate, setLateShipPoDate] = useState<Date | null>(null);
  const [lateShipPoDateMax, setLateShipPoDateMax] = useState<Date | null>(null);
  const [pickupNumber, setPickupNumber] = useState("");
  const [poItems, setPoItems] = useState<PoItem[]>([]);
  const [feasiblePOs, setFeasiblePOs] = useState<PurchaseOrderRelease[]>([]);
  const [planToLocationGid, setPlanToLocationGid] = useState("");
  const [dcOptions, setDcOptions] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLiftgateRequired, setIsLiftgateRequired] = useState("");
  const nmfcClasses = [
    "50",
    "55",
    "60",
    "65",
    "70",
    "77.5",
    "85",
    "92.5",
    "100",
    "110",
    "125",
    "150",
    "175",
    "200",
    "250",
    "300",
    "400",
    "500",
  ];
  const hazmats = ["No", "Yes"];
  const [poItemShipUnits, setPoItemShipUnits] = useState<PoItemShipUnit[]>([]);
  const [shippingOriginRemarks, setShippingOriginRemarks] = useState("");
  const [wareHouseRemarks, setWareHouseRemarks] = useState("");
  const [hasValidationErrors, setHasValidationErrors] = useState(false);
  const [hasShipQuantityValidationErrors, setHasShipQuantityValidationErrors] =
    useState(false);
  const [isEarlyProductReadyDateNotValid, setEarlyProductReadyDateNotValid] =
    useState(false);
  const [openSuccessAlert, setSuccessAlertOpen] = useState(false);
  const [openFailureAlert, setFailureAlertOpen] = useState(false);
  const po = (location?.state as IState)?.purchaseOrderRelease;
  const vendorLocations = (location?.state as IState)?.locations;
  var hazmatCodes = (location?.state as IState)?.hazmatCodes;
  var purchaseOrder = po
    ? {
        ...po,
        itemShipUnits: po.itemShipUnits?.map((itemShipUnit, index) => {
          return { ...itemShipUnit, shipUnitId: `${index}` };
        }),
      }
    : undefined;
  var pageEditable = (location?.state as IState)?.isPageEditable;
  const searchOrderRelease = (location?.state as IState)?.searchOrderRelease;
  const [originalPurchaseOrder, setOriginalPurchaseOrder] =
    useState<PurchaseOrderRelease>();
  const [failureDailogContent, setFailureDailogContent] = useState("");

  const authHeader = localStorage.getItem("authHeader");
  const [selectAll, setSelectAll] = useState(false);
  const [isPageEditable, setIsPageEditable] = useState(false);
  const [isEditButtonEnabled, setIsEditButtonEnabled] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [originalShipQuantityMap, setOriginalShipQuantityMap] = useState<
    Record<string, number>
  >({});
  const [originalRemainingQuantityMap, setOriginalRemainingQuantityMap] =
    useState<Record<string, number>>({});

  const convertDateToStr = (dateTime: string) => {
    return dateTime ? dateTime.replace("T", " ") : "";
  };

  const toNumber = (value: unknown): number => {
    const numericValue =
      typeof value === "string" ? parseInt(value, 10) : Number(value);
    return Number.isFinite(numericValue) ? numericValue : 0;
  };

  const parseDateOrNull = (
    value?: string | number | Date | null,
  ): Date | null => {
    if (value === undefined || value === null || value === "") {
      return null;
    }
    const parsedDate = new Date(value);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
  };

  const formatWithCommas = (value: number): string =>
    toNumber(value)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const getPoItemKey = (item: PoItem): string => `${item.poId}__${item.itemId}`;

  const buildOriginalShipQuantityMap = (
    items: PoItem[] | undefined,
  ): Record<string, number> =>
    (items ?? []).reduce(
      (map, item) => {
        map[getPoItemKey(item)] = toNumber(item.shipQuantity);
        return map;
      },
      {} as Record<string, number>,
    );

  const buildOriginalRemainingQuantityMap = (
    items: PoItem[] | undefined,
  ): Record<string, number> =>
    (items ?? []).reduce(
      (map, item) => {
        map[getPoItemKey(item)] = toNumber(item.remainingQuantity);
        return map;
      },
      {} as Record<string, number>,
    );

  const syncOriginalShipQuantities = (items: PoItem[]) => {
    setOriginalShipQuantityMap((prevMap) => {
      const nextMap = { ...prevMap };
      items.forEach((item) => {
        const key = getPoItemKey(item);
        if (nextMap[key] === undefined) {
          nextMap[key] = toNumber(item.shipQuantity);
        }
      });
      return nextMap;
    });
  };

  const syncOriginalRemainingQuantities = (items: PoItem[]) => {
    setOriginalRemainingQuantityMap((prevMap) => {
      const nextMap = { ...prevMap };
      items.forEach((item) => {
        const key = getPoItemKey(item);
        if (nextMap[key] === undefined) {
          nextMap[key] = toNumber(item.remainingQuantity);
        }
      });
      return nextMap;
    });
  };

  const getOriginalShipQuantity = (item: PoItem): number => {
    const key = getPoItemKey(item);
    const mapValue = originalShipQuantityMap[key];
    return mapValue !== undefined ? mapValue : toNumber(item.shipQuantity);
  };

  const getOriginalRemainingQuantity = (item: PoItem): number => {
    const key = getPoItemKey(item);
    const mapValue = originalRemainingQuantityMap[key];
    return mapValue !== undefined ? mapValue : toNumber(item.remainingQuantity);
  };

  const getDisplayRemainingQuantity = (item: PoItem): number => {
    const originalRemaining = getOriginalRemainingQuantity(item);
    const originalShip = getOriginalShipQuantity(item);
    const currentShip = toNumber(item.shipQuantity);
    return Math.max(originalRemaining + originalShip - currentShip, 0);
  };

  const hasEditableQuantity = (item: PoItem): boolean =>
    getOriginalRemainingQuantity(item) + getOriginalShipQuantity(item) > 0;

  const getMaxEditableShipQuantity = (item: PoItem): number =>
    getOriginalShipQuantity(item) + getOriginalRemainingQuantity(item);

  const isExceedingEditableShipQuantity = (item: PoItem): boolean =>
    toNumber(item.shipQuantity) > getMaxEditableShipQuantity(item);

  const isUnchangedShipQuantityForEdit = (item: PoItem): boolean =>
    toNumber(item.shipQuantity) === getOriginalShipQuantity(item);

  const isInvalidDivisibleShipQuantityForEdit = (item: PoItem): boolean =>
    item.quantityPerCarton !== 0 && isDivisibleShipQuantity(item);

  const isInvalidShipQuantityForEdit = (item: PoItem): boolean =>
    isUnchangedShipQuantityForEdit(item)
      ? false
      : isInvalidDivisibleShipQuantityForEdit(item) ||
        isExceedingEditableShipQuantity(item);

  const hasInvalidShipQuantitiesForEdit = (items: PoItem[]): boolean =>
    items?.some((item) => isInvalidShipQuantityForEdit(item));

  const isOverEditableShipQuantityForEdit = (item: PoItem): boolean =>
    isUnchangedShipQuantityForEdit(item)
      ? false
      : isExceedingEditableShipQuantity(item);

  useEffect(() => {
    const vendorId = localStorage.getItem("vendorId") ?? "";
    if (!shipFrom && purchaseOrder !== undefined) {
      updateShipFromLoation(vendorId, purchaseOrder?.shipFrom);
    }
    setVendorId(vendorId);
    if (pageEditable) {
      setIsPageEditable(pageEditable);
    }
    if (purchaseOrder !== undefined) {
      setOriginalPurchaseOrder(JSON.parse(JSON.stringify(purchaseOrder)));
      updatePurchaseOrderInformation(purchaseOrder);
    }
  }, [location]);

  function updatePurchaseOrderInformation(purchaseOrder: PurchaseOrderRelease) {
    setVendorId(purchaseOrder?.vendorId);
    setMasterVendorName(purchaseOrder?.masterVendorName);
    setFreightTerms(purchaseOrder?.freightTerms);
    setOrderReleaseId(purchaseOrder?.orderReleaseId);
    setOrderReleaseStatus(purchaseOrder.orderReleaseStatus);
    setEarlyPickupDate(convertDateToStr(purchaseOrder?.earlyPickupDate));
    setLatePickupDate(convertDateToStr(purchaseOrder?.latePickupDate));
    setEarlyDeliveryDate(convertDateToStr(purchaseOrder?.earlyDeliveryDate));
    setLateDeliveryDate(convertDateToStr(purchaseOrder?.lateDeliveryDate));
    setTotalWeightValue(purchaseOrder?.totalWeightValue);
    setTotalVolumeValue(purchaseOrder?.totalVolumeValue);
    setPalletSpaces(purchaseOrder?.palletSpaces);
    setPallets(purchaseOrder?.pallets);
    setPalletSlipSheets(purchaseOrder?.palletSlipSheets);
    setTotalCartons(purchaseOrder?.totalCartons);
    setLoadMethod(purchaseOrder?.loadMethod);
    setEarlyShipDate(parseDateOrNull(purchaseOrder?.earlyShipDate));
    const initialEarlyProductReadyDate = parseDateOrNull(
      purchaseOrder?.earlyProductReadyDate,
    );
    setEarlyProductReadyDate(initialEarlyProductReadyDate);
    setEarlyProductReadyDateStart(
      new Date(
        new Date(purchaseOrder?.earlyProductReadyDateStart).setHours(
          0,
          0,
          0,
          0,
        ),
      ),
    );
    setEarlyProductReadyDateEnd(
      new Date(
        new Date(purchaseOrder?.earlyProductReadyDateEnd).setHours(
          23,
          59,
          59,
          999,
        ),
      ),
    );
    if (pageEditable && initialEarlyProductReadyDate) {
      setLateProductReadyDateWithOffset(initialEarlyProductReadyDate);
    } else {
      setLateProductReadyDate(
        parseDateOrNull(purchaseOrder?.lateProductReadyDate),
      );
    }
    setEarlyProductReadyDateMinimum(
      parseDateOrNull(purchaseOrder?.earlyProductReadyDateMinimum),
    );
    setShipToTemp(purchaseOrder?.shipTo);
    setShipFrom(purchaseOrder?.shipFrom);
    setPoItems(purchaseOrder?.items);
    setOriginalShipQuantityMap(
      buildOriginalShipQuantityMap(purchaseOrder?.items),
    );
    setOriginalRemainingQuantityMap(
      buildOriginalRemainingQuantityMap(purchaseOrder?.items),
    );
    setPoItemShipUnits(purchaseOrder?.itemShipUnits);
    setPlanToLocationGid(purchaseOrder?.planToLocationGid);
    setLateShipPoDate(
      purchaseOrder?.lateShipPoDate
        ? new Date(
            new Date(purchaseOrder?.lateShipPoDate).setHours(23, 59, 59, 999),
          )
        : null,
    );
    setEarlyShipPoDate(parseDateOrNull(purchaseOrder?.earlyShipPoDate));
    setPickupNumber(purchaseOrder?.vendorPickupNumber);
    setWareHouseRemarks(purchaseOrder?.wareHouseRemarks);
    setIsLiftgateRequired(
      purchaseOrder?.dtreLiftgateRequired === "false" ? "" : "LIFTGATE",
    );
    setIsEditButtonEnabled(purchaseOrder?.editable);
  }

  useEffect(() => {
    if (dcOptions.length === 0) {
      getDestinationDetails();
    }
  }, [shipToTemp]);

  useEffect(() => {
    if (isPageEditable && shipToAddress) {
      getFeasiblePurchaseOrderList();
    }
  }, [isPageEditable, shipToAddress]);

  useEffect(() => {
    const allSelected = feasiblePOs.every((po) => po.isSelected);
    const noneSelected = feasiblePOs.every((po) => !po.isSelected);

    if (allSelected && feasiblePOs.length > 0) {
      setSelectAll(true);
    } else if (noneSelected) {
      setSelectAll(false);
    } else {
      setSelectAll(false);
    }
  }, [feasiblePOs]);

  useEffect(() => {
    if (isPageEditable && earlyProductReadyDate) {
      setLateProductReadyDateWithOffset(earlyProductReadyDate);
    }
  }, [isPageEditable, earlyProductReadyDate]);

  const parsePoDate = (dateStr: string) => {
    if (!dateStr) {
      return null;
    }
    const [year, month, day] = dateStr.split("T")[0].split("-").map(Number);
    if (!year || !month || !day) {
      return null;
    }
    return new Date(year, month - 1, day);
  };

  const updateShipPoDatesFromItems = (items: PoItem[]) => {
    const earlyDates = items
      .map((item) => parsePoDate(item.earlyPickupDate))
      .filter((date): date is Date => date !== null);
    const lateDates = items
      .map((item) => parsePoDate(item.latePickupDate))
      .filter((date): date is Date => date !== null);

    if (earlyDates.length > 0) {
      const minEarlyDate = new Date(
        Math.min(...earlyDates.map((date) => date.getTime())),
      );
      setEarlyShipPoDate(minEarlyDate);
    }

    if (lateDates.length > 0) {
      const maxLateDate = new Date(
        Math.max(...lateDates.map((date) => date.getTime())),
      );
      setLateShipPoDate(maxLateDate);
    }
  };

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    setSelectAll(checked);

    setFeasiblePOs((prevPOs) =>
      prevPOs.map((po) => ({
        ...po,
        isSelected: checked,
      })),
    );

    let newPoItems: PoItem[];
    if (checked) {
      const initialItems = originalPurchaseOrder
        ? JSON.parse(JSON.stringify(originalPurchaseOrder?.items))
        : [];
      const allFeasibleItems = feasiblePOs.flatMap((po) => po.items);
      newPoItems = [...initialItems, ...allFeasibleItems];
    } else {
      setFeasiblePOs((prevPOs) =>
        prevPOs.map((po) => {
          const newPo = {
            ...po,
            items: po.items.map((item) => ({
              ...item,
              shipQuantity: 0,
              cartons: 0,
              nmfc: nmfcDefaultValue,
              unCode: "",
              hazmat: false,
              shipQuantityWithCommas: false,
            })),
          };
          return newPo;
        }),
      );

      newPoItems = originalPurchaseOrder
        ? JSON.parse(JSON.stringify(originalPurchaseOrder?.items))
        : [];
    }
    setPoItems(newPoItems);
    syncOriginalShipQuantities(newPoItems);
    syncOriginalRemainingQuantities(newPoItems);
    updateShipPoDatesFromItems(newPoItems);
    calculateShipUnits(newPoItems);
  };

  const handleRowCheckboxChange = (
    selectedPurchaseOrder: PurchaseOrderRelease,
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const checked = event.target.checked;
    const selectedPurchaseOrderId = selectedPurchaseOrder?.purchaseOrderId;

    let newPoItems: PoItem[];
    setFeasiblePOs((prevPOs) =>
      prevPOs.map((po) => {
        const newPo = {
          ...po,
          isSelected:
            po.purchaseOrderId === selectedPurchaseOrderId
              ? checked
              : po.isSelected,
        };
        if (newPo.purchaseOrderId === selectedPurchaseOrderId && !checked) {
          newPo.items = newPo.items.map((item) => ({
            ...item,
            shipQuantity: 0,
            cartons: 0,
            nmfc: nmfcDefaultValue,
            unCode: "",
            hazmat: false,
            shipQuantityWithCommas: false,
          }));
        }
        return newPo;
      }),
    );

    if (checked) {
      newPoItems = [
        ...poItems,
        ...feasiblePOs
          ?.filter((po) => po?.purchaseOrderId === selectedPurchaseOrderId)
          ?.flatMap((po) => po.items),
      ];
    } else {
      newPoItems = poItems.filter((item) =>
        item.poId === selectedPurchaseOrder?.purchaseOrderId &&
        selectedPurchaseOrder?.isPartiallyReleased
          ? selectedPurchaseOrder.items.some(
              (selectedPoItem) => selectedPoItem.itemId !== item.itemId,
            )
          : item.poId !== selectedPurchaseOrderId,
      );
    }
    setPoItems(newPoItems);
    syncOriginalShipQuantities(newPoItems);
    syncOriginalRemainingQuantities(newPoItems);
    updateShipPoDatesFromItems(newPoItems);
    calculateShipUnits(newPoItems);
  };

  const closeSuccessAlertDialog = () => {
    setSuccessAlertOpen(false);
    history.push({
      pathname: "/searchOrderRelease",
      state: { searchOrderRelease: searchOrderRelease, navigatedBack: true },
    });
  };

  const closeFailureAlertDialog = () => {
    setFailureAlertOpen(false);
  };

  const businessDaysToAdd = (date: Date | null): number => {
    if (!date || Number.isNaN(date.getTime())) {
      return 0;
    }
    const day = date.getDay();
    return day === 0 || day === 6 ? 3 : 2;
  };

  const setLateProductReadyDateWithOffset = (date: Date | null) => {
    if (!date || Number.isNaN(date.getTime())) {
      setLateProductReadyDate(null);
      return;
    }
    const offset = businessDaysToAdd(date);
    setLateProductReadyDate(addBusinessDays(date, offset));
  };

  const addBusinessDays = (date: Date, days: number) => {
    const result = new Date(date.getTime());
    let addedDays = 0;
    while (addedDays < days) {
      result.setDate(result.getDate() + 1);
      const dayOfWeek = result.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        addedDays += 1;
      }
    }
    return result;
  };

  const updateShipFromLoation = (vendorId: string, shipFrom: string) => {
    if (vendorLocations !== null && vendorLocations.length > 0) {
      const shipFromOptions: string[] = vendorLocations
        ?.filter(
          (item: { locationXId: string }) => item.locationXId === shipFrom,
        )
        .map(
          (item: {
            locationName: string;
            streetAddress: string;
            provinceCode: string;
            postalCode: string;
          }) =>
            item.locationName +
            " " +
            item.streetAddress +
            " " +
            item.provinceCode +
            " " +
            item.postalCode,
        );

      setShipFromLocation(shipFromOptions ? shipFromOptions[0] : "");
      setShipFrom(shipFrom);
      var shipFromRemarks: string = vendorLocations?.filter(
        (item: { locationXId: string }) => item.locationXId === shipFrom,
      )[0]?.remark;
      setShippingOriginRemarks(shipFromRemarks);
    }
  };

  const editOrderRelease = async () => {
    setIsPageEditable(true);
    await getFeasiblePurchaseOrderList();
  };

  const handleShipFrom = (e: any) => {
    setShipFrom(e.target.value);
    var filteredLocation = vendorLocations?.filter(
      (item: { locationXId: string }) => item.locationXId === e.target.value,
    );
    setShippingOriginRemarks(filteredLocation[0]?.remark);
  };

  const handleShipingOriginRemarks = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    setShippingOriginRemarks(e.target.value);
  };

  const handleAdvancedSelection = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    const selectedValue = e.target.value;
    setAdvancedOption(selectedValue);
  };

  const handlePickupNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPickupNumber(
      e.target.value.replace(/[^a-zA-Z0-9-,.;=+()!@#$%{}/]/g, ""),
    );
  };

  const handleShipQuantityValidation = () => {
    var hasErrors = poItems?.some((item: PoItem) =>
      isInvalidShipQuantityForEdit(item),
    );
    setHasShipQuantityValidationErrors(hasErrors);
  };

  const handleShipQuantityOnBlur = (e: any) => {
    const itemId: string = e.target.getAttribute("data-item-id");
    const poId: string = e.target.getAttribute("data-po-id");
    const newPoItems: PoItem[] = [...poItems];
    const item: PoItem = newPoItems.find(
      (i) => i.itemId === itemId && i.poId === poId,
    )!;
    item.shipQuantityWithCommas = false;
    setPoItems(newPoItems);
  };

  const handleShipQuantityOnFocus = (e: any) => {
    const itemId: string = e.target.getAttribute("data-item-id");
    const poId: string = e.target.getAttribute("data-po-id");
    const newPoItems: PoItem[] = [...poItems];
    const item: PoItem = newPoItems.find(
      (i) => i.itemId === itemId && i.poId === poId,
    )!;
    item.shipQuantityWithCommas = true;
    setPoItems(newPoItems);
  };

  const handleShipQuantity = (e: any) => {
    const qty = e.target.value.replace(/[^0-9\s]/g, "");
    const itemId = e.target.getAttribute("data-item-id");
    const poId = e.target.getAttribute("data-po-id");
    const newPoItems: PoItem[] = [...poItems];
    const item = newPoItems.find(
      (i) => i.itemId === itemId && i.poId === poId,
    )!;

    item.shipQuantity = qty;
    item.cartons = Math.ceil(Number(qty) / item.quantityPerCarton);

    setPoItems(newPoItems);

    const resolvedNmfc =
      item.nmfc === null ||
      item.nmfc === undefined ||
      item.nmfc === "null" ||
      item.nmfc === ""
        ? nmfcDefaultValue
        : item.nmfc;

    calculateShipUnits(newPoItems, [resolvedNmfc]);
    handleShipQuantityValidation();
  };

  const handlenmfc = (e: any) => {
    const itemId = e.target.getAttribute("data-item-id");
    const poId = e.target.getAttribute("data-po-id");
    const newPoItems: PoItem[] = [...poItems];
    const item = newPoItems.find(
      (i) => i.itemId === itemId && i.poId === poId,
    )!;

    const oldNmfc =
      item.nmfc === null ||
      item.nmfc === undefined ||
      item.nmfc === "null" ||
      item.nmfc === ""
        ? nmfcDefaultValue
        : item.nmfc;

    const eventValue = e.target.value;

    const newNmfc =
      eventValue === null ||
      eventValue === undefined ||
      eventValue === "null" ||
      eventValue === ""
        ? nmfcDefaultValue
        : eventValue;

    item.nmfc = eventValue;
    setPoItems(newPoItems);
    const qty = item.shipQuantity;

    if (qty !== undefined && qty !== null && qty !== 0) {
      calculateShipUnits(newPoItems, [oldNmfc, newNmfc]);
    } else {
      calculateShipUnits(newPoItems);
    }
  };

  const handleHazmat = (e: any) => {
    const itemId: string = e.target.getAttribute("data-item-id");
    const poId: string = e.target.getAttribute("data-po-id");
    const newPoItems: PoItem[] = [...poItems];
    const item: PoItem = newPoItems.find(
      (i) => i.itemId === itemId && i.poId === poId,
    )!;
    if (e.target.value === "No") {
      item.unCode = "";
    }
    item.hazmat = e.target.value === "Yes" ? true : false;
    setPoItems(newPoItems);
  };

  const handleUnCode = (itemId: string, poId: string, newValue: string) => {
    const newPoItems = [...poItems];
    const item = newPoItems.find((i) => i.itemId === itemId && i.poId === poId);

    if (item) {
      item.unCode = newValue || "";
      setPoItems(newPoItems);
    }
  };

  const handleWareHouseRemarks = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    setWareHouseRemarks(
      e.target.value.replace(/[^a-zA-Z0-9-,.;=+()!@#$%{}/\s]/g, ""),
    );
  };

  const convertDate = (dateTime: Date, timeZone: string) => {
    let date = ("0" + dateTime.getDate()).slice(-2);
    let month = ("0" + (dateTime.getMonth() + 1)).slice(-2);
    let year = dateTime.getFullYear();
    let covertedDate = year + "-" + month + "-" + date + timeZone;
    return covertedDate;
  };

  const convertDateStr = (dateTimeStr: string) => {
    let dateTime = new Date(dateTimeStr);
    let date = ("0" + dateTime.getDate()).slice(-2);
    let month = ("0" + (dateTime.getMonth() + 1)).slice(-2);
    let year = dateTime.getFullYear();
    let covertedDate = year + "-" + month + "-" + date;
    return covertedDate;
  };

  let itemLineNumber = 0;
  const getShipUnitLines = (nmfc: string, shipUnitGid: string) => {
    let shipUnitLines: any = [];
    let shipUnitLineNumber = 0;
    poItems.forEach((row: PoItem) => {
      if (row.shipQuantity > 0 && row.nmfc === nmfc) {
        shipUnitLines.push({
          transactionCode: "IU",
          shipUnitLineBeanData: {
            shipUnitGid: shipUnitGid,
            shipUnitLineNo: shipUnitLineNumber + 1,
            orderReleaseLineGid: orderReleaseId + "-" + itemLineNumber,
            packagedItemGid: row.itemId,
            obLineGid: row.obLineGid,
          },
        });
        shipUnitLineNumber++;
        itemLineNumber++;
      }
    });
    return shipUnitLines;
  };

  const getDestinationDetails = () => {
    setIsLoading(true);
    const orderReleaseUrl = `${process.env.REACT_APP_BACKEND_URL}/matm/dcCity/${purchaseOrder?.destination}`;

    getJsonResult(orderReleaseUrl)
      .then((response) => response.json())
      .then((data) => {
        setDcOptions(data);
        setDestinationValue(data);

        const shipToFiltered: string[] = data?.filter(
          (item: string) => item.split(" ")[0] === shipToTemp,
        );
        setShipTo(shipToFiltered ? shipToFiltered[0] : "");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const formatToMMDDYYYY = (dateStr: string) => {
    if (!dateStr) return dateStr;
    const onlyDate = dateStr.split("T")[0];
    const [year, month, day] = onlyDate.split("-");
    return `${month}/${day}/${year}`;
  };

  const formatDateToMMDDYYYY = (date: Date) => {
    if (!date || !(date instanceof Date) || isNaN(date.getTime())) return "";

    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    const year = date.getUTCFullYear();

    return `${month}/${day}/${year}`;
  };

  const getFeasiblePurchaseOrderList = () => {
    setIsLoading(true);
    const activePoItems = poItems.filter(
      (item) =>
        !item.cancelled &&
        item.remainingQuantity != null &&
        item.remainingQuantity > 0,
    );

    if (activePoItems.length === 0) {
      setIsLoading(false);
      setFeasiblePOs([]);
      return;
    }

    const maxEarlyPickupDate = activePoItems.reduce((max, item) => {
      const current = item.earlyPickupDate;
      return current > max ? current : max;
    }, activePoItems[0].earlyPickupDate);

    const minLatePickupDate = activePoItems.reduce((min, item) => {
      const current = item.latePickupDate;
      return current < min ? current : min;
    }, activePoItems[0].latePickupDate);

    const feasiblePOSearchUrl = `${process.env.REACT_APP_BACKEND_URL}/api/purchaseOrder/feasibleSearch`;
    const offset = businessDaysToAdd(earlyProductReadyDate);

    const lprd = addBusinessDays(earlyProductReadyDate ?? new Date(), offset);
    const feasiblePOSearchRequest = {
      earlyProductReadyDate: document
        ?.getElementById("earlyShipReleaseDate")
        ?.getAttribute("value"),
      lateProductReadyDate: formatDateToMMDDYYYY(lprd),
      feasiblePOStartDate: formatToMMDDYYYY(maxEarlyPickupDate),
      feasiblePOEndDate: formatToMMDDYYYY(minLatePickupDate),
      freightTerms: freightTerms,
      shipTo: shipToAddress.split(" ")[0],
      vendorId: vendorId,
      requestFrom: "updateOrderRelease",
      orderReleasePOItemIdMap: purchaseOrder?.items.reduce((map, item) => {
        if (typeof item.poId === "string" && typeof item.itemId === "string") {
          const poId = item.poId;
          const itemId = item.itemId;

          if (map[poId]) {
            map[poId] = `${map[poId]},${itemId}`;
          } else {
            map[poId] = itemId;
          }
        }
        return map;
      }, {} as POItemIdMap),
    };

    post(feasiblePOSearchUrl, feasiblePOSearchRequest)
      .then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          return response.json();
        } else {
          throw response;
        }
      })
      .then((data) => {
        if (originalPurchaseOrder !== undefined) {
          const items = JSON.parse(
            JSON.stringify(originalPurchaseOrder?.items),
          );
          const itemShipUnits = JSON.parse(
            JSON.stringify(originalPurchaseOrder?.itemShipUnits),
          );

          setPoItems(items);
          setOriginalRemainingQuantityMap(
            buildOriginalRemainingQuantityMap(items),
          );
          syncOriginalShipQuantities(items);
          updateShipPoDatesFromItems(items);
          setPoItemShipUnits(itemShipUnits);
        }
        setFeasiblePOs(data);
      })
      .catch((error) => {
        error.text().then((errMessage: any) => {
          setFailureDailogContent(
            "Error when fetching Feasible Purchase Order list:\n" + errMessage,
          );
        });
        setFailureAlertOpen(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const calculateShipUnits = (
    currentPoItems: PoItem[],
    resetNmfcs: string[] = [],
  ) => {
    const shipUnitsArray: PoItemShipUnit[] = [];
    const nmfcClassSet = new Set<string>();
    const totalCartonsMap = new Map<string, number>();

    const nmfcTemplateMap = new Map<string, PoItemShipUnit>(
      poItemShipUnits.map((unit) => [unit.nmfcClass, unit]),
    );

    currentPoItems.forEach((item) => {
      if (!item.shipQuantity || item.shipQuantity <= 0) return;

      const itemNmfc =
        item.nmfc === "null" || !item.nmfc ? nmfcDefaultValue : item.nmfc;

      const currentCartons = totalCartonsMap.get(itemNmfc) ?? 0;
      const newTotalCartons = currentCartons + (item.cartons ?? 0);
      totalCartonsMap.set(itemNmfc, newTotalCartons);

      if (!nmfcClassSet.has(itemNmfc)) {
        const existingInState = poItemShipUnits.find(
          (u) => u.nmfcClass === itemNmfc,
        );
        const template = nmfcTemplateMap.get(itemNmfc);
        const shouldReset = resetNmfcs.includes(itemNmfc) || !existingInState;

        const newShipUnit = new PoItemShipUnit(
          itemNmfc,
          shouldReset ? "PALLET" : (existingInState?.loadMethod ?? "PALLET"),
          shouldReset
            ? "PALLET"
            : (existingInState?.priorLoadMethod ?? "PALLET"),
          shouldReset ? 0 : (existingInState?.pallet ?? 0),
          shouldReset ? 0 : (existingInState?.palletSpaces ?? 0),
          shouldReset ? 0 : (existingInState?.volume ?? 0),
          shouldReset ? 0 : (existingInState?.weight ?? 0),
          newTotalCartons,
          itemNmfc,
          shouldReset ? 0 : (existingInState?.volume ?? 0),
          true,
          true,
          shouldReset ? false : (existingInState?.oversized ?? false),
          template?.existingUnit ?? false,
        );

        nmfcClassSet.add(itemNmfc);
        shipUnitsArray.push(newShipUnit);
      } else {
        const existingUnit = shipUnitsArray.find(
          (u) => u.nmfcClass === itemNmfc,
        );
        if (existingUnit) {
          existingUnit.cartons = newTotalCartons;
        }
      }
    });

    setPoItemShipUnits([...shipUnitsArray]);
  };

  const handleShipUnitsChange = (updatedUnits: PoItemShipUnit[]) => {
    setPoItemShipUnits(updatedUnits);
  };

  const setDestinationValue = (dcOptions: string[]) => {
    dcOptions.forEach((eachOption) => {
      if (eachOption?.split(" ")[0] === purchaseOrder?.destination) {
        setShipToAddress(eachOption);
      }
    });
  };

  const finishOrderRelease = () => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    poItems.forEach((row: PoItem) => {
      return {
        ...row,
        originFacilityId: shipFrom,
        destinationFacilityId: shipToAddress?.split(" ")[0],
      };
    });

    let shipUnits: any = [];
    poItemShipUnits?.forEach((shipUnit: PoItemShipUnit) => {
      let shipUnitGid = orderReleaseId + "-" + shipUnit.shipUnitId;
      shipUnits.push({
        shipUnitBeanData: {
          shipUnitGid: shipUnitGid,
          shipUnitXid: shipUnitGid?.split(".")[1],
          unitWeight: {
            value:
              shipUnit.pallet > 0
                ? shipUnit.weight / shipUnit.pallet
                : shipUnit.weight / shipUnit.cartons, // floor load method
            uomCode: "LB",
          },
          unitVolume: {
            value:
              shipUnit.pallet > 0
                ? shipUnit.volume / shipUnit.pallet
                : shipUnit.volume / shipUnit.cartons, // floor load method
            uomCode: "CUFT",
          },
          orderReleaseId: orderReleaseId,
          shipUnitCount:
            shipUnit.pallet > 0 ? Number(shipUnit.pallet) : shipUnit.cartons,
          totalGrossWeight: {
            value: shipUnit.weight / 1,
            uomCode: "LB",
          },
          totalGrossVolume: {
            value: shipUnit.volume / 1,
            uomCode: "CUFT",
          },
          attributeNumber1: Number(shipUnit.palletSpaces),
          unitNetWeight: {
            value:
              shipUnit.pallet > 0
                ? shipUnit.weight / shipUnit.pallet
                : shipUnit.weight / shipUnit.cartons,
            uomCode: "LB",
          },
          unitNetVolume: {
            value:
              shipUnit.pallet > 0
                ? shipUnit.volumeBkp / shipUnit.pallet
                : shipUnit.volumeBkp / shipUnit.cartons,
            uomCode: "CUFT",
          },
          flexCommodityCode: shipUnit.nmfcClass,
          flexCommodityQualGid: "NMFC_CLASS",
          shipUnitLine: getShipUnitLines(shipUnit.nmfcClass, shipUnitGid),
        },
      });
    });

    const updatedItems = poItems
      ? poItems
          .filter((item) => {
            const qty =
              item && item.shipQuantity ? Number(item.shipQuantity) : 0;
            return item && qty > 0;
          })
          .map((item) => {
            item.nmfc =
              !item.nmfc || item.nmfc === "null" ? nmfcDefaultValue : item.nmfc;
            item.cancelled = false;
            return item;
          })
      : [];

    const cancelledItems = poItems
      ? poItems
          .filter((item) => {
            const hasId = item && item.orderReleaseLineId ? true : false;
            const qty =
              item && item.shipQuantity ? Number(item.shipQuantity) : 0;

            return hasId && qty === 0;
          })
          .map((item) => {
            item.nmfc =
              !item.nmfc || item.nmfc === "null" ? nmfcDefaultValue : item.nmfc;
            item.cancelled = true;
            return item;
          })
      : [];

    const filteredItems = [...updatedItems, ...cancelledItems];

    let orderJson = {
      orderReleaseId: purchaseOrder?.orderReleaseId,
      purchaseOrderId: purchaseOrder?.purchaseOrderId,
      totalProcessedItemCount: purchaseOrder?.totalProcessedItemCount,
      vendorId: vendorId,
      shipFrom: shipFrom,
      shipTo: shipToAddress?.split(" ")[0],
      earlyPickupDate:
        earlyProductReadyDate !== null
          ? convertDate(earlyProductReadyDate, "T00:00:01")
          : null,
      latePickupDate:
        lateProductReadyDate !== null
          ? convertDate(lateProductReadyDate, "T23:59:00")
          : null,
      earlyDeliveryDate:
        earlyShipPoDate !== null
          ? convertDate(earlyShipPoDate, "T00:00:01")
          : null,
      lateDeliveryDate:
        lateShipPoDate !== null
          ? convertDate(lateShipPoDate, "T23:59:00")
          : null,
      freightTerms: freightTerms,
      items: filteredItems,
      itemShipUnits: poItemShipUnits,
      vendorPickupNumber: pickupNumber,
      wareHouseRemarks: wareHouseRemarks,
      dtreLiftgateRequired: advancedOption === "LIFTGATE" ? "LIFTGATE" : "",
    };

    var updateOrderReleaseUrl = `${process.env.REACT_APP_BACKEND_URL}/api/orderRelease/update`;
    post(updateOrderReleaseUrl, orderJson)
      .then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          return response.text();
        } else {
          throw response;
        }
      })
      .then((data) => {
        setOrderReleaseId(data);
        setSuccessAlertOpen(true);
      })
      .catch((error) => {
        setIsSubmitting(false);
        error.text().then((errMessage: any) => {
          setFailureDailogContent(
            "Error when finishing updating OrderRelease:\n" + errMessage,
          );
        });
        setFailureAlertOpen(true);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const validationHandler = (hasErrors: boolean) => {
    setHasValidationErrors(hasErrors);
  };

  const shipComplete = () => {
    const newPoItems: PoItem[] = [...poItems];
    const allNmfcs: string[] = [];

    newPoItems.forEach((item) => {
      const safeQuantityPerCarton =
        !item.quantityPerCarton || item.quantityPerCarton === 0
          ? 1
          : item.quantityPerCarton;
      const availableQuantity = getDisplayRemainingQuantity(item);

      if (availableQuantity > 0) {
        const currentShipQuantity = toNumber(item.shipQuantity);
        const desiredShipQuantity = currentShipQuantity + availableQuantity;
        item.shipQuantity = desiredShipQuantity;
        item.cartons = Math.ceil(desiredShipQuantity / safeQuantityPerCarton);

        const nmfc = item.nmfc || nmfcDefaultValue;
        if (!allNmfcs.includes(nmfc)) allNmfcs.push(nmfc);
      }
    });

    setPoItems(newPoItems);
    calculateShipUnits(newPoItems, allNmfcs);
  };

  const cancelEdit = () => {
    if (originalPurchaseOrder !== undefined) {
      purchaseOrder = JSON.parse(JSON.stringify(originalPurchaseOrder));
    }
    if (purchaseOrder !== undefined) {
      updatePurchaseOrderInformation(purchaseOrder);
    }
    setSelectAll(false);
    setFeasiblePOs((prevPOs) =>
      prevPOs.map((po) => ({
        ...po,
        isSelected: false,
      })),
    );
    setIsPageEditable(false);
  };

  const routeToSearchOrderRelease = () => {
    history.push({
      pathname: "/searchOrderRelease",
      state: { searchOrderRelease: searchOrderRelease, navigatedBack: true },
    });
  };

  const validateEarlyShipReleaseDate = (
    newValue: Date | null,
    earlyShipReleaseDateStart: Date,
    earlyShipReleaseDateEnd: Date,
  ) => {
    setEarlyProductReadyDateNotValid(
      newValue !== null
        ? !(
            newValue >= earlyShipReleaseDateStart &&
            newValue <= earlyShipReleaseDateEnd
          )
        : true,
    );
  };

  const isFormConflicted = () => {
    return (
      isEmpty(shipFrom) ||
      isEmpty(shipFromLocation) ||
      isEarlyProductReadyDateNotValid ||
      hasValidationErrors ||
      hasShipQuantityValidationErrors ||
      poItemShipUnits?.length === 0 ||
      hasInvalidUnCode(poItems) ||
      isInvalidMaxPickupNumber(pickupNumber) ||
      isInvalidMaxWareHouseRemarks(wareHouseRemarks) ||
      hasInvalidShipUnits(poItemShipUnits) ||
      hasInvalidTotals(poItemShipUnits)
    );
  };

  const goToNextInvalidField = () => {
    if (isEmpty(shipFrom) || isEmpty(shipFromLocation)) {
      focusOnField("shipFromOverride");
    } else if (hasInvalidShipQuantitiesForEdit(poItems)) {
      const item = poItems?.find(isInvalidShipQuantityForEdit);
      focusOnField("shipQuantity" + item?.itemId + item?.poId);
    } else if (hasInvalidUnCode(poItems)) {
      const item = poItems?.find(
        (item) => hasInvalidPoItemUnCode(item) && item?.hazmat,
      );
      focusOnField("unCode" + item?.itemId + item?.poId);
    } else if (hasInvalidSlipSheets(poItemShipUnits)) {
      focusOnField(
        "pallet" + poItemShipUnits?.find(isInvalidSlipSheetsValue)?.shipUnitId,
      );
    } else if (hasInvalidPalletSpaces(poItemShipUnits)) {
      focusOnField(
        "palletSpaces" +
          poItemShipUnits?.find(isInvalidPalletSpacesValue)?.shipUnitId,
      );
    }
  };

  const roundUp = (
    value: string | number | null | undefined,
  ): number | string => {
    const numericValue = Number(value);
    const isNumber = typeof numericValue === "number" && isFinite(numericValue);
    if (isNumber) {
      return Math.ceil(numericValue);
    } else {
      return "0";
    }
  };

  const isEmpty = (val: any) => {
    if (val == null) return true;

    if (typeof val === "string" || Array.isArray(val)) {
      return val.length === 0;
    }

    if (typeof val === "object") {
      return Object.keys(val).length === 0;
    }

    return false;
  };

  const isSameDay = (a: Date, b: Date) => a.toDateString() === b.toDateString();

  const shouldDisableDate = (date: Date) => {
    const start = new Date(earlyProductReadyDateStart);
    const end = new Date(earlyProductReadyDateEnd);

    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    return d < start || d > end;
  };

  const allDatesDisabled = () => {
    const start = new Date(earlyProductReadyDateStart);
    const end = new Date(earlyProductReadyDateEnd);
    const current = new Date(start);
    while (current <= end) {
      if (!shouldDisableDate(current)) {
        return false; // found atleast one valid date
      }
      current.setDate(current.getDate() + 1);
    }
    return true; // all dates are disabled
  };

  return (
    <section className="sectionHeadingPadding">
      <div
        id="purchaseOrderReleasePage"
        style={{ margin: "auto", width: "100%" }}
      >
        <div className="intro-container">
          <div className="shipper-info-container">
            <div
              className="intro"
              style={
                isPageEditable
                  ? {
                      width: "100%",
                      marginRight: "auto",
                      marginLeft: "150px",
                    }
                  : {
                      width: "100%",
                      marginRight: "auto",
                      marginLeft: "auto",
                    }
              }
            >
              <div
                id="purchaseOrderReleaseManager"
                className="section-heading mb-4"
              >
                <span
                  className="section-heading-lower"
                  style={{
                    fontSize: "2rem",
                    textAlign: "center",
                    color: "#6b3a06",
                    fontWeight: 500,
                    paddingBottom: "20px",
                  }}
                >
                  READY TO SHIP MANAGER
                </span>
              </div>
              <form>
                <div style={{ display: "flex" }}>
                  {isPageEditable ? (
                    <>
                      <div style={{ width: "52%", marginLeft: "-8%" }}>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="vendorId"
                            value={vendorId}
                            variant="outlined"
                            label="Vendor ID"
                            disabled
                            sx={{ width: "25%" }}
                          />
                          <TextField
                            className="form-control"
                            id="masterVendorName"
                            value={masterVendorName}
                            variant="outlined"
                            label="Master Vendor Name"
                            disabled
                            sx={{ width: "75%" }}
                          />
                        </div>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="orderReleaseIdValue"
                            value={orderReleaseId}
                            variant="outlined"
                            label="Supplier Routing Request ID"
                            sx={{ width: "40%" }}
                            disabled
                          />
                          <TextField
                            className="form-control"
                            id="orderReleaseStatusValue"
                            value={orderReleaseStatus}
                            variant="outlined"
                            label="Supplier Routing Request Status"
                            sx={{ width: "60%" }}
                            disabled
                          />
                        </div>
                        <div
                          className="form-group py-2"
                          style={{ position: "relative", minHeight: "1px" }}
                        >
                          <div
                            className="text-danger"
                            id="eprdWarningInfo"
                            title="Please note:The selected Early Product Ready Date is after the Late PO Pickup Date and may be subject to an OTIF chargeback penalty"
                            style={{
                              position: "absolute",
                              right: "92%",
                              marginRight: "20px",
                              width: "260px",
                              whiteSpace: "normal",
                              lineHeight: 1.35,
                              textAlign: "left",
                              display:
                                (earlyProductReadyDate?.getTime() || 0) >
                                (lateShipPoDate?.getTime() || 0)
                                  ? "block"
                                  : "none",
                            }}
                          >
                            Please note:The selected Early Product Ready Date is
                            after the Late PO Pickup Date and may be subject to
                            an OTIF chargeback penalty
                          </div>
                          <div>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DatePicker
                                label="EARLY PRODUCT READY DATE"
                                views={["year", "month", "day"]}
                                value={earlyProductReadyDate}
                                onChange={(newValue: any) => {
                                  const isSame =
                                    earlyProductReadyDate &&
                                    isSameDay(newValue, earlyProductReadyDate);
                                  if (isSame) {
                                    setEarlyProductReadyDate(newValue);
                                    setLateProductReadyDateWithOffset(newValue);
                                    validateEarlyShipReleaseDate(
                                      newValue,
                                      earlyProductReadyDateStart,
                                      earlyProductReadyDateEnd,
                                    );
                                  }
                                }}
                                onAccept={(newValue: any) => {
                                  setEarlyProductReadyDate(newValue);
                                  setLateProductReadyDateWithOffset(newValue);
                                  validateEarlyShipReleaseDate(
                                    newValue,
                                    earlyProductReadyDateStart,
                                    earlyProductReadyDateEnd,
                                  );
                                }}
                                allowSameDateSelection={true}
                                shouldDisableDate={(date: Date) =>
                                  date < new Date(earlyProductReadyDateStart) ||
                                  date > new Date(earlyProductReadyDateEnd)
                                }
                                renderInput={(params: any) => (
                                  <TextField
                                    {...params}
                                    id="earlyShipReleaseDate"
                                    className="form-control"
                                    helperText={null}
                                    error={
                                      allDatesDisabled() ? false : params.error
                                    }
                                    onKeyDown={(e) => {
                                      e.preventDefault();
                                    }}
                                  />
                                )}
                              />
                            </LocalizationProvider>
                          </div>
                        </div>
                        <div className="form-group py-2">
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              label="LATE PRODUCT READY DATE"
                              views={["year", "month", "day"]}
                              value={lateProductReadyDate}
                              disableOpenPicker={true}
                              onChange={() => {}}
                              renderInput={(params: any) => (
                                <TextField
                                  {...params}
                                  id="lateShipReleaseDate"
                                  className="form-control"
                                  helperText={null}
                                />
                              )}
                              disabled
                            />
                          </LocalizationProvider>
                        </div>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="earlyDeliveryDateValue"
                            value={earlyDeliveryDate}
                            variant="outlined"
                            label="Early Delivery"
                            disabled
                          />
                        </div>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="lateDeliveryDateValue"
                            value={lateDeliveryDate}
                            variant="outlined"
                            label="Late Delivery"
                            disabled
                          />
                        </div>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="pickupNumber"
                            value={pickupNumber ? pickupNumber : ""}
                            onChange={handlePickupNumber}
                            variant="outlined"
                            label="Pickup Number"
                            InputLabelProps={{ shrink: true }}
                          />
                          <br />
                          {isInvalidMaxPickupNumber(pickupNumber) && (
                            <span
                              id={"pickupNumberError"}
                              style={{
                                fontWeight: "bold",
                                color: "red",
                              }}
                            >
                              Can not exceed 30 characters.
                            </span>
                          )}
                        </div>
                      </div>
                      <div style={{ width: "45%", marginLeft: "30px" }}>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="palletsValue"
                            value={pallets}
                            variant="outlined"
                            label="Pallets"
                            sx={{ width: "33%" }}
                            disabled
                          />
                          <TextField
                            className="form-control"
                            id="slipSheetsValue"
                            value={palletSlipSheets}
                            variant="outlined"
                            label="Slip Sheets"
                            sx={{ width: "33%" }}
                            disabled
                          />
                          <TextField
                            className="form-control"
                            id="palletSpacesValue"
                            value={palletSpaces}
                            variant="outlined"
                            label="Pallet Spaces"
                            sx={{ width: "33%" }}
                            disabled
                          />
                        </div>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="totalWeightValue"
                            value={roundUp(totalWeightValue)}
                            variant="outlined"
                            label="Total Weight"
                            sx={{ width: "33%" }}
                            disabled
                          />
                          <TextField
                            className="form-control"
                            id="totalVolumeValue"
                            value={roundUp(totalVolumeValue)}
                            variant="outlined"
                            label="Total volume"
                            sx={{ width: "33%" }}
                            disabled
                          />
                          <TextField
                            className="form-control"
                            id="totalCartonsValue"
                            value={totalCartons}
                            variant="outlined"
                            label="Total Cartons"
                            sx={{ width: "33%" }}
                            disabled
                          />
                        </div>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="loadMethodValue"
                            value={loadMethod}
                            variant="outlined"
                            label="Load Method"
                            disabled
                          />
                        </div>
                        <div className="form-group py-2">
                          <TextField
                            select
                            label="Ship From Location"
                            value={shipFrom || ""}
                            error={
                              isEmpty(shipFrom) || isEmpty(shipFromLocation)
                            }
                            className="form-control"
                            id="shipFromOverride"
                            onChange={handleShipFrom}
                            fullWidth
                          >
                            <MenuItem value="">
                              <em>Select a Location</em>
                            </MenuItem>
                            {vendorLocations?.map((loc: Location) => (
                              <MenuItem
                                key={loc?.locationXId}
                                value={loc?.locationXId}
                              >
                                {`${loc?.locationName || ""} ${
                                  loc?.streetAddress || ""
                                }  ${loc?.city || ""} 
                                ${loc?.provinceCode || ""} ${
                                  loc?.postalCode || ""
                                }`}
                              </MenuItem>
                            ))}
                          </TextField>
                        </div>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="shipToValue"
                            value={shipTo}
                            variant="outlined"
                            label="Ship To"
                            InputLabelProps={{ shrink: true }}
                            disabled
                          />
                        </div>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="freightTermsValue"
                            value={freightTerms}
                            variant="outlined"
                            label="Freight Terms"
                            disabled
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div style={{ width: "50%" }}>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="vendorId"
                            value={vendorId}
                            variant="outlined"
                            label="Vendor ID"
                            disabled
                            sx={{ width: "25%" }}
                          />
                          <TextField
                            className="form-control"
                            id="masterVendorName"
                            value={masterVendorName}
                            variant="outlined"
                            label="Master Vendor Name"
                            disabled
                            sx={{ width: "75%" }}
                          />
                        </div>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="orderReleaseIdValue"
                            value={orderReleaseId}
                            variant="outlined"
                            label="Supplier Routing Request ID"
                            sx={{ width: "40%" }}
                            disabled
                          />
                          <TextField
                            className="form-control"
                            id="orderReleaseStatusValue"
                            value={orderReleaseStatus}
                            variant="outlined"
                            label="Supplier Routing Request Status"
                            sx={{ width: "60%" }}
                            disabled
                          />
                        </div>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="Early PO Pickup Date"
                            value={earlyPickupDate}
                            variant="outlined"
                            label="Early Product Ready"
                            disabled
                          />
                        </div>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="latePickupDateValue"
                            value={latePickupDate}
                            variant="outlined"
                            label="Late PO Pickup Date"
                            disabled
                          />
                        </div>
                        <div
                          className="form-group py-2"
                          style={{ position: "relative", minHeight: "1px" }}
                        >
                          <div
                            className="text-danger"
                            style={{
                              position: "absolute",
                              right: "92%",
                              marginRight: "20px",
                              width: "260px",
                              whiteSpace: "normal",
                              lineHeight: 1.35,
                              textAlign: "left",
                              display:
                                (earlyProductReadyDate?.getTime() || 0) >
                                (lateShipPoDate?.getTime() || 0)
                                  ? "block"
                                  : "none",
                            }}
                          >
                            Please note:The selected Early Product Ready Date is
                            after the Late PO Pickup Date and may be subject to
                            an OTIF chargeback penalty
                          </div>
                          <div>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DatePicker
                                label="EARLY PRODUCT READY DATE"
                                views={["year", "month", "day"]}
                                value={earlyProductReadyDate}
                                minDate={
                                  earlyProductReadyDateMinimum || new Date()
                                }
                                onChange={(newValue: any) => {
                                  setEarlyProductReadyDate(newValue);
                                  setLateProductReadyDateWithOffset(newValue);
                                  validateEarlyShipReleaseDate(
                                    newValue,
                                    earlyProductReadyDateStart,
                                    earlyProductReadyDateEnd,
                                  );
                                }}
                                shouldDisableDate={(date: Date) =>
                                  date < new Date(earlyProductReadyDateStart) ||
                                  date > new Date(earlyProductReadyDateEnd)
                                }
                                renderInput={(params: any) => (
                                  <TextField
                                    {...params}
                                    type="hidden"
                                    style={{ display: "none" }}
                                    id="earlyShipReleaseDate"
                                    className="form-control"
                                    helperText={null}
                                    onKeyDown={(e) => {
                                      e.preventDefault();
                                    }}
                                  />
                                )}
                              />
                            </LocalizationProvider>
                          </div>
                        </div>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            label="LATE PRODUCT READY DATE"
                            views={["year", "month", "day"]}
                            value={lateProductReadyDate}
                            disableOpenPicker={true}
                            onChange={() => {}}
                            renderInput={(params: any) => (
                              <TextField
                                {...params}
                                type="hidden"
                                style={{ display: "none" }}
                                id="lateShipReleaseDate"
                                className="form-control"
                                helperText={null}
                              />
                            )}
                            disabled
                          />
                        </LocalizationProvider>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="earlyDeliveryDateValue"
                            value={earlyDeliveryDate}
                            variant="outlined"
                            label="Early Delivery"
                            disabled
                          />
                        </div>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="lateDeliveryDateValue"
                            value={lateDeliveryDate}
                            variant="outlined"
                            label="Late Delivery"
                            disabled
                          />
                        </div>
                      </div>
                      <div style={{ width: "50%", marginLeft: "75px" }}>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="palletsValue"
                            value={pallets}
                            variant="outlined"
                            label="Pallets"
                            sx={{ width: "33%" }}
                            disabled
                          />
                          <TextField
                            className="form-control"
                            id="slipSheetsValue"
                            value={palletSlipSheets}
                            variant="outlined"
                            label="Slip Sheets"
                            sx={{ width: "33%" }}
                            disabled
                          />
                          <TextField
                            className="form-control"
                            id="palletSpacesValue"
                            value={palletSpaces}
                            variant="outlined"
                            label="Pallet Spaces"
                            sx={{ width: "33%" }}
                            disabled
                          />
                        </div>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="totalWeightValue"
                            value={roundUp(totalWeightValue)}
                            variant="outlined"
                            label="Total Weight"
                            sx={{ width: "33%" }}
                            disabled
                          />
                          <TextField
                            className="form-control"
                            id="totalVolumeValue"
                            value={roundUp(totalVolumeValue)}
                            variant="outlined"
                            label="Total volume"
                            sx={{ width: "33%" }}
                            disabled
                          />
                          <TextField
                            className="form-control"
                            id="totalCartonsValue"
                            value={totalCartons}
                            variant="outlined"
                            label="Total Cartons"
                            sx={{ width: "33%" }}
                            disabled
                          />
                        </div>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="loadMethodValue"
                            value={loadMethod}
                            variant="outlined"
                            label="Load Method"
                            disabled
                          />
                        </div>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="shipFromValue"
                            value={shipFromLocation}
                            variant="outlined"
                            label="Ship From"
                            error={isEmpty(shipFromLocation)}
                            InputLabelProps={{ shrink: true }}
                            disabled
                            sx={{
                              "& .MuiInputLabel-root.Mui-error.Mui-disabled": {
                                color: "error.main",
                              },
                              "& .MuiOutlinedInput-root.Mui-error.Mui-disabled .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "error.main",
                                },
                              "& .MuiFormHelperText-root.Mui-error.Mui-disabled":
                                {
                                  color: "error.main",
                                },
                            }}
                          />
                        </div>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="shipToValue"
                            value={shipTo}
                            variant="outlined"
                            label="Ship To"
                            InputLabelProps={{ shrink: true }}
                            disabled
                          />
                        </div>
                        <div className="form-group py-2">
                          <TextField
                            className="form-control"
                            id="freightTermsValue"
                            value={freightTerms}
                            variant="outlined"
                            label="Freight Terms"
                            disabled
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </form>
            </div>
          </div>
          {isPageEditable ? (
            <div
              className="feasible-po-item-container"
              style={{
                minWidth: "30%",
                marginLeft: "125px",
                display: "block",
                position: "relative",
              }}
            >
              <h3
                id="feasiblePOHeader"
                style={{
                  fontSize: "1.4rem",
                  color: "#6b3a06",
                  fontWeight: 500,
                }}
              >
                Feasible Ship With POs
              </h3>
              <div className="table-container-scroll">
                <table id="feasiblePOTable">
                  <thead style={{ borderBottom: "2px solid black" }}>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          id="selectAllPOs"
                          checked={selectAll}
                          className="select-all-checkbox"
                          onChange={handleSelectAll}
                        />
                      </th>
                      <th>Purchase Orders</th>
                      <th>Remaining Qty</th>
                    </tr>
                  </thead>
                  <tbody>
                    {feasiblePOs?.map(
                      (purchaseOrderRelease: PurchaseOrderRelease) => (
                        <tr key={purchaseOrderRelease?.purchaseOrderId}>
                          <td>
                            <input
                              id={purchaseOrderRelease?.purchaseOrderId}
                              type="checkbox"
                              className="row-checkbox"
                              checked={Boolean(
                                purchaseOrderRelease?.isSelected,
                              )}
                              onChange={(e) =>
                                handleRowCheckboxChange(purchaseOrderRelease, e)
                              }
                            />
                          </td>
                          {purchaseOrderRelease?.isPartiallyReleased ? (
                            <>
                              <td style={{ backgroundColor: "lightgreen" }}>
                                {purchaseOrderRelease?.purchaseOrderId}
                              </td>
                              <td style={{ backgroundColor: "lightgreen" }}>
                                {purchaseOrderRelease?.items.reduce(
                                  (acc, item) => {
                                    if (
                                      !item ||
                                      item.remainingQuantity === undefined ||
                                      item.remainingQuantity === null
                                    ) {
                                      return acc;
                                    }

                                    let remainingQuantity =
                                      item.remainingQuantity;

                                    if (typeof remainingQuantity === "string") {
                                      remainingQuantity =
                                        parseFloat(remainingQuantity);
                                      if (isNaN(remainingQuantity)) {
                                        remainingQuantity = 0;
                                      }
                                    }
                                    return acc + remainingQuantity;
                                  },
                                  0,
                                )}
                              </td>
                            </>
                          ) : (
                            <>
                              <td>{purchaseOrderRelease?.purchaseOrderId}</td>
                              <td>{purchaseOrderRelease?.remainingQuantity}</td>
                            </>
                          )}
                        </tr>
                      ),
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          ) : null}
        </div>
        <div
          id="poItemsTable"
          style={{
            whiteSpace: "nowrap",
            margin: "auto",
            textAlign: "center",
            overflow: "auto",
          }}
        >
          <table className="table" style={{ width: "80%", margin: "auto" }}>
            <thead>
              <tr>
                <th>PO ID</th>
                <th>Item ID</th>
                <th>Item description</th>
                <th>
                  Early <br /> Pickup
                </th>
                <th>
                  Late <br /> Pickup
                </th>
                <th>
                  Early <br /> Delivery
                </th>
                <th>
                  Late <br /> Delivery
                </th>
                <th>
                  Ordered <br /> Qty
                </th>
                <th>
                  Remaining <br /> Qty
                </th>
                <th>
                  {isPageEditable && (
                    <div>
                      <button
                        id="shipCompleteButton"
                        type="button"
                        className="btn btn-success"
                        onClick={() => shipComplete()}
                        style={{ backgroundColor: "#006600" }}
                      >
                        Ship Complete
                      </button>{" "}
                      <br />
                    </div>
                  )}
                  Ship Qty
                </th>
                <th>
                  Qty <br /> Per Carton
                </th>
                <th>Cartons</th>
                <th>NMFC Class</th>
                <th>Hazmat?</th>
                <th>UN Code</th>
              </tr>
            </thead>
            <tbody>
              {poItems?.map((item: PoItem) => (
                <tr>
                  <td>{item?.poId}</td>
                  <td>{item?.itemId}</td>
                  <td>{item?.itemDescription}</td>
                  <td>{convertDateStr(item?.earlyPickupDate)}</td>
                  <td>{convertDateStr(item?.latePickupDate)}</td>
                  <td>{convertDateStr(item?.earlyDeliveryDate)}</td>
                  <td>{convertDateStr(item?.lateDeliveryDate)}</td>
                  <td>
                    {item?.orderedQuantity
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                  <td>{formatWithCommas(getDisplayRemainingQuantity(item))}</td>
                  {isPageEditable ? (
                    <td>
                      <FlagableTextField
                        id={"shipQuantity" + item?.itemId + item?.poId}
                        data-item-id={item?.itemId}
                        data-po-id={item?.poId}
                        name="shipQuantity"
                        className="form-control"
                        value={
                          item?.shipQuantityWithCommas
                            ? item?.shipQuantity.toString().replace(/,/g, "")
                            : item?.shipQuantity
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }
                        onChange={handleShipQuantity}
                        onBlur={handleShipQuantityOnBlur}
                        onFocus={handleShipQuantityOnFocus}
                        disabled={!hasEditableQuantity(item)}
                        inputProps={{
                          "data-item-id": item?.itemId,
                          "data-po-id": item?.poId,
                        }}
                      />
                      <br />
                      {isInvalidDivisibleShipQuantityForEdit(item) && (
                        <span
                          id={"shipQuantityError" + item?.itemId + item?.poId}
                          style={{
                            fontWeight: "bold",
                            color: "red",
                          }}
                        >
                          Must be divisible <br />
                          by Qty Per Carton.
                        </span>
                      )}
                      {isInvalidDivisibleShipQuantityForEdit(item) &&
                        isOverEditableShipQuantityForEdit(item) && <br />}
                      {isOverEditableShipQuantityForEdit(item) && (
                        <span
                          id={"shipQuantityError" + item?.itemId + item?.poId}
                          style={{
                            fontWeight: "bold",
                            color: "red",
                          }}
                        >
                          The Ship Qty must not be <br />
                          greater than Remaining Qty (
                          {formatWithCommas(getMaxEditableShipQuantity(item))}
                          ).
                        </span>
                      )}
                    </td>
                  ) : (
                    <td>
                      {item?.shipQuantityWithCommas
                        ? item?.shipQuantity.toString().replace(/,/g, "")
                        : item?.shipQuantity
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </td>
                  )}
                  <td>
                    {item.quantityPerCarton
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                  <td>
                    {item.cartons
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                  {isPageEditable ? (
                    <td>
                      <DropDown
                        codes={nmfcClasses}
                        elementId={"nmfc" + item?.itemId + item?.poId}
                        data-item-id={item?.itemId}
                        data-po-id={item?.poId}
                        inputProps={{
                          "data-item-id": item?.itemId,
                          "data-po-id": item?.poId,
                        }}
                        value={item?.nmfc}
                        onChange={handlenmfc}
                        defaultValue="70"
                      />
                    </td>
                  ) : (
                    <td>{item?.nmfc}</td>
                  )}
                  {isPageEditable ? (
                    <td>
                      <TextField
                        className="form-control"
                        id={"hazmat" + item?.itemId + item?.poId}
                        data-item-id={item?.itemId}
                        data-po-id={item?.poId}
                        name="hazmatDropDown"
                        select
                        value={item?.hazmat ? "Yes" : "No"}
                        defaultValue={"No"}
                        onChange={handleHazmat}
                        inputProps={{
                          "data-item-id": item?.itemId,
                          "data-po-id": item?.poId,
                        }}
                        SelectProps={{
                          native: true,
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        style={{ width: "140px" }}
                      >
                        {hazmats?.map((hazmat) => (
                          <option key={hazmat} value={hazmat}>
                            {hazmat}
                          </option>
                        ))}
                      </TextField>
                    </td>
                  ) : (
                    <td>{item?.hazmat ? "Yes" : "No"}</td>
                  )}
                  {isPageEditable ? (
                    <td>
                      <Tooltip
                        id={"unCodeToolTip" + item?.itemId + item?.poId}
                        data-item-id={item?.itemId}
                        data-po-id={item?.poId}
                        disableHoverListener={!item?.hazmat}
                        open={false}
                        title={
                          <div
                            style={{
                              whiteSpace: "pre-line",
                              fontSize: "1.8em",
                            }}
                            id={"unCodeToolTipOne" + item?.itemId}
                          >
                            {
                              "Provide the UN number of the hazardous substances"
                            }
                          </div>
                        }
                        placement="bottom"
                      >
                        <span
                          style={{ display: "inline-block", width: "140px" }}
                        >
                          <AutoDropDown
                            elementId={"unCode" + item?.itemId + item?.poId}
                            data-item-id={item?.itemId}
                            data-po-id={item?.poId}
                            value={item?.unCode}
                            codes={hazmatCodes}
                            name="unCodeDropDown"
                            disable={!item?.hazmat}
                            required={item?.hazmat}
                            variant="outlined"
                            onChange={(e: any, newValue: any) =>
                              handleUnCode(item?.itemId, item?.poId, newValue)
                            }
                            defaultValue=""
                            sx={{
                              width: "100%",
                              "& .MuiInputBase-root.Mui-disabled": {
                                backgroundColor: "lightgray",
                              },
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: "rgba(0, 0, 0, 0.6)",
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor:
                                  item?.hazmat && hasInvalidPoItemUnCode(item)
                                    ? "red !important"
                                    : "",
                              },
                            }}
                          />
                        </span>
                      </Tooltip>
                    </td>
                  ) : (
                    <td>{item?.unCode}</td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <br />
        <OrderReleaseDetailsPoItemShipUnitPage
          poItemShipUnitsProps={poItemShipUnits}
          onShipUnitsChange={handleShipUnitsChange}
          validationHandler={validationHandler.bind(this)}
          disableShipUnits={isPageEditable}
        />
      </div>
      {isPageEditable ? (
        <>
          <div className="row justify-content-center">
            <div
              className="col-md"
              style={{ paddingLeft: "250px", width: "50%" }}
            >
              <div className="form-group py-2">
                <div className="input-group" style={{ width: "80%" }}>
                  <TextField
                    id="wareHouseRemarks"
                    className="form-control"
                    label="Additional Supplier Routing Request Remarks"
                    value={wareHouseRemarks}
                    onChange={handleWareHouseRemarks}
                    minRows={3}
                    multiline
                  />
                </div>
                {isInvalidMaxWareHouseRemarks(wareHouseRemarks) && (
                  <span
                    id={"wareHouseRemarksError"}
                    style={{
                      fontWeight: "bold",
                      color: "red",
                    }}
                  >
                    Can not exceed 80 characters.
                  </span>
                )}
              </div>
            </div>
            <div
              className="col-md"
              style={{ paddingRight: "90px", width: "50%" }}
            >
              <div className="form-group py-2">
                <div className="input-group" style={{ width: "80%" }}>
                  <TextField
                    className="form-control"
                    id="shippingOriginRemarks"
                    variant="outlined"
                    label="Default Shipping Origin Remarks"
                    value={shippingOriginRemarks}
                    onChange={handleShipingOriginRemarks}
                    disabled
                    minRows={3}
                    multiline
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              marginLeft: "180px",
              marginRight: "25px",
            }}
          >
            <CollapsibleSection id="advancedOptions" title="Advanced">
              <div
                style={{
                  width: "15%",
                  marginTop: "10px",
                }}
              >
                <TextField
                  id="specialServices"
                  select
                  label="Special Services"
                  className="form-control"
                  SelectProps={{
                    native: true,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  defaultValue={isLiftgateRequired ? "LIFTGATE" : ""}
                  onChange={handleAdvancedSelection}
                >
                  <option key="" value="">
                    NONE
                  </option>
                  <option key="LIFTGATE" value="LIFTGATE">
                    LIFTGATE
                  </option>
                </TextField>
              </div>
            </CollapsibleSection>
          </div>
        </>
      ) : (
        <div className="row justify-content-center">
          <div
            className="col-md"
            style={{ paddingLeft: "250px", width: "50%" }}
          >
            <label style={{ color: "black" }}>
              <b>Supplier Routing Request Remarks :</b> &nbsp;&nbsp;
            </label>
            <span>{wareHouseRemarks}</span>
          </div>
          <div className="col-md" style={{ width: "30%" }}>
            <label style={{ color: "black" }}>
              <b>Default Shipping Origin Remarks :</b> &nbsp;&nbsp;
            </label>
            <span>{shippingOriginRemarks}</span>
          </div>
          <div
            className="col-md"
            style={{ paddingLeft: "100px", width: "30%" }}
          >
            <label style={{ color: "black" }}>
              <b>Special Services :</b> &nbsp;&nbsp;
            </label>
            <span>{isLiftgateRequired ? "LIFTGATE" : "NONE"}</span>
          </div>
        </div>
      )}
      <br />
      {isPageEditable ? null : (
        <>
          <div id="shipmentsTable">
            <table className="table" style={{ width: "70%", margin: "auto" }}>
              <thead>
                <tr>
                  <th>Shipment ID</th>
                  <th>Assigned Carrier</th>
                  <th>Shipment Status</th>
                  <th>Delivery Appointment ID</th>
                  <th>Pickup Number</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{purchaseOrder?.shipmentId}</td>
                  <td>{purchaseOrder?.assignedCarrier}</td>
                  <td>{purchaseOrder?.shipmentStatus}</td>
                  <td>{purchaseOrder?.deliveryAppointmentNumber}</td>
                  <td>{purchaseOrder?.pickupNumber}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}
      {isPageEditable ? (
        <div>
          <div className="row justify-content-center m-xl-2">
            <button
              id="goToErrorsButton"
              type="button"
              className="btn"
              style={{
                width: "auto",
              }}
              disabled={!isFormConflicted()}
              onClick={() => goToNextInvalidField()}
            >
              {isFormConflicted() ? "Go to errors" : "No errors"}
            </button>
          </div>
          <div className="row justify-content-center m-xl-2">
            <button
              id="readyToShipFinishButton"
              type="button"
              className="btn btn-success"
              style={{
                width: "auto",
                marginRight: ".4em",
              }}
              disabled={isFormConflicted()}
              onClick={() => finishOrderRelease()}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
            <button
              id="cancelEditPOButton"
              className="btn btn-dark"
              style={{
                width: "auto",
              }}
              onClick={() => cancelEdit()}
            >
              Cancel
            </button>
          </div>
          <div className="row justify-content-center">
            <div
              className="col-md"
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <br></br>
              <p>
                <strong>
                  By clicking submit, I acknowledge that failure to provide
                  accurate and timely information may result in future financial
                  penalties.
                </strong>
              </p>
            </div>
          </div>
        </div>
      ) : (
        <>
          {" "}
          <div className="row justify-content-center m-xl-2">
            {" "}
            <button
              id="cancelSearchPOButton"
              className="btn btn-dark"
              style={{
                width: "auto",
                marginRight: "16px",
              }}
              onClick={() => routeToSearchOrderRelease()}
            >
              Back
            </button>
            {isEditButtonEnabled && (
              <button
                id="editOrderReleaseButton"
                className="btn btn-dark"
                style={{
                  width: "auto",
                }}
                onClick={() => editOrderRelease()}
              >
                Edit
              </button>
            )}
          </div>
        </>
      )}
      <div id="alertDialog">
        <Dialog open={openSuccessAlert} id="statusDialog">
          <DialogTitle id="statusDialogTitle">Success!</DialogTitle>
          <DialogContent>
            <DialogContentText id="statusDialogText">
              Order {orderReleaseId} updated successfully
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              id="statusDialogButton"
              onClick={closeSuccessAlertDialog}
              color="primary"
              autoFocus
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openFailureAlert} id="statusDialog">
          <DialogTitle id="statusDialogText">Error!</DialogTitle>
          <DialogContent>
            <DialogContentText>{failureDailogContent}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              id="statusDialogButton"
              onClick={closeFailureAlertDialog}
              color="primary"
              autoFocus
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </section>
  );
};

export default OrderReleaseDetailsPage;
